import React, { useEffect, useState } from "react";
import "../CSS/EmployerDashboard.css";
import PostOpportunityModal from "./PostOpportunityModal";
import ApplicantsModal from "./ApplicantsModal";
import Cookies from "js-cookie";
import logo from "../../assets/icone.png";

const EmployerDashboard = () => {
  const [opportunities, setOpportunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOpportunityModal, setShowOpportunityModal] = useState(false);
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [organization_name, setOrganization] = useState('');

    useEffect(()=>{
  
      setOrganization(Cookies.get("organization_name"));
  
    },[]);
  



  const handleOpportunityPosted = (newOpportunity) => {
    if (newOpportunity) {
      setOpportunities((prev) => [
        {
          id: Date.now(),
          organizationName: newOpportunity.organizationName || "Enterprise Africa",
          jobTitle: newOpportunity.jobTitle || "New Attachment Opportunity",
          county: newOpportunity.county || "Nairobi",
          industry: newOpportunity.industry || "General",
          attachmentType: newOpportunity.attachmentType || "Full-Time",
          openings: newOpportunity.openings || 1,
          contactPhone: newOpportunity.contactPhone || "+254 700 000 000",
          jobWebsite: newOpportunity.jobWebsite || "https://yourdomain.com",
          description: newOpportunity.description || "No description provided.",
          duration: newOpportunity.duration || "3 Months",
          applicationsSubmitted: 0,
          postedTimeAgo: "Just now",
          applicantsList: []
        },
        ...prev
      ]);
    }

    setShowOpportunityModal(false);
  };

  const totalOpportunities = opportunities.length;
  const totalOpenings = opportunities.reduce((acc, curr) => acc + (curr.openings || 0), 0);
  const totalApplications = opportunities.reduce((acc, curr) => acc + (curr.applicationsSubmitted || 0), 0);

  return (
    <div className="employer-page">
      {/* HEADER NAVBAR */}
      <header className="top-navbar">
        <div className="brand-area">
          <img
             src={logo}
             alt="Advenware Career Link"
             className="landing-logo-image"
          />
          <div className="brand-text">
            <strong>Advenware</strong>
            <span>Careere Link</span>
          </div>
        </div>

        <div className="account-area">
          <button className="notification">
            ♢
            <span></span>
          </button>

          <div className="employer-avatar">EA</div>

          <div className="account-details">
            <strong>{organization_name}</strong>
            <small>Employer</small>
          </div>

          <button className="account-menu">⋮</button>
        </div>
      </header>

      {/* MAIN CONTENT */}
      <main className="main-content">
        {/* HERO SECTION */}
        <section className="welcome-section">
          <div>
            <div className="small-green-label">EMPLOYER DASHBOARD</div>
            <h1>
              Attachment Opportunities
              <br />
              Posted by Employer
            </h1>
            <p>
              Manage, monitor, and review all active attachment positions created for student applicants.
            </p>
          </div>

          <button
            className="post-button"
            onClick={() => setShowOpportunityModal(true)}
          >
            + Post new opportunity
          </button>
        </section>

        {/* STATS SUMMARY CARDS */}
        <section className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon blue">💼</div>
            <div>
              <span>POSTED OPPORTUNITIES</span>
              <strong>{loading ? "--" : totalOpportunities}</strong>
              <p>Active listings</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon green">✓</div>
            <div>
              <span>TOTAL OPENINGS</span>
              <strong>{loading ? "--" : totalOpenings}</strong>
              <p>Available slots</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon orange">♙</div>
            <div>
              <span>TOTAL APPLICATIONS</span>
              <strong>{loading ? "--" : totalApplications}</strong>
              <p>Received to date</p>
            </div>
          </div>
        </section>

        {/* OPPORTUNITIES LIST SECTION */}
        <section className="opportunities-section">
          <div className="section-header">
            <div>
              <span>OPPORTUNITIES MANAGEMENT</span>
              <h2>Number of Attachment opportunities posted ({totalOpportunities})</h2>
              <p>Click on any job listing or application tag to view candidate details.</p>
            </div>

            <button
              className="post-button-secondary"
              onClick={() => setShowOpportunityModal(true)}
            >
              + Post opportunity
            </button>
          </div>

          <div className="opportunities-list">
            {loading ? (
              <div className="loading">
                <div className="spinner"></div>
                <p>Fetching posted opportunities...</p>
              </div>
            ) : opportunities.length === 0 ? (
              <div className="empty">
                <div className="empty-icon">💼</div>
                <h3>No attachment opportunities posted yet</h3>
                <p>Click '+ Post opportunity' above to publish your first attachment slot.</p>
              </div>
            ) : (
              opportunities.map((item) => (
                <div
                  className="opportunity-card clickable"
                  key={item.id}
                  onClick={() => setSelectedOpportunity(item)}
                >
                  <div className="opp-header">
                    <div className="opp-header-main">
                      <span className="badge-industry">{item.industry}</span>
                      <h3>{item.jobTitle}</h3>
                      <p className="org-name">🏢 {item.organizationName}</p>
                    </div>
                    <div className="opp-time-posted">
                      <span>Posted {item.postedTimeAgo}</span>
                    </div>
                  </div>

                  <p className="opp-description">{item.description}</p>

                  <div className="opp-details-grid">
                    <div className="detail-item">
                      <small>COUNTY LOCATION</small>
                      <strong>📍 {item.county}</strong>
                    </div>

                    <div className="detail-item">
                      <small>ATTACHMENT TYPE</small>
                      <strong>⚡ {item.attachmentType}</strong>
                    </div>

                    <div className="detail-item">
                      <small>DURATION</small>
                      <strong>◷ {item.duration}</strong>
                    </div>

                    <div className="detail-item">
                      <small>NUMBER OF OPENINGS</small>
                      <strong>👥 {item.openings} Openings</strong>
                    </div>

                    <div className="detail-item">
                      <small>APPLICATIONS SUBMITTED</small>
                      <strong className="text-green clickable-badge">
                        📩 {item.applicationsSubmitted} Applicants (Click to view)
                      </strong>
                    </div>

                    <div className="detail-item">
                      <small>CONTACT NUMBER</small>
                      <strong>📞 {item.contactPhone}</strong>
                    </div>
                  </div>

                  <div className="opp-footer">
                    <a
                      href={item.jobWebsite}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="website-link"
                      onClick={(e) => e.stopPropagation()}
                    >
                      🔗 Visit Job Website ({item.jobWebsite})
                    </a>
                  </div>
                </div>
              ))
            )}
          </div>

          {!loading && opportunities.length > 0 && (
            <div className="list-footer">
              <span>
                Showing <b>{opportunities.length}</b> opportunities
              </span>
              <span>Advenware Careere Link</span>
            </div>
          )}
        </section>
      </main>

      {/* FOOTER */}
      <footer className="page-footer">
        <div>© 2026 Advenware Careere Link</div>
        <div>Student • Employer • Agent</div>
      </footer>

      {/* POST OPPORTUNITY MODAL */}
      {showOpportunityModal && (
        <PostOpportunityModal
          onClose={() => setShowOpportunityModal(false)}
          onOpportunityPosted={handleOpportunityPosted}
        />
      )}

      {/* APPLICANTS POPUP MODAL */}
      {selectedOpportunity && (
        <ApplicantsModal
          opportunity={selectedOpportunity}
          onClose={() => setSelectedOpportunity(null)}
        />
      )}
    </div>
  );
};

export default EmployerDashboard;